/* eslint-disable no-comments/disallowComments */
import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { CustomerSupportState, CustomerSupportAemLabel, CustomerUserRawData } from './definition/customer-support.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomerSupportFactory } from './customer-support.factory';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { ApiResponse } from '../../definitions/api-response.interface';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedUtilService } from '../../services/shared/shared-util.service';
import { AemApiService } from '../../services/api/api.aem.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class CustomerSupportService 
{
	public state$: BehaviorSubject<CustomerSupportState> = new BehaviorSubject<CustomerSupportState>(CustomerSupportFactory.build());
	constructor(private translate: TranslateService, private readonly apiService: ApiService, private readonly aemApiService:AemApiService, public localStorageService: LocalStorageService, private readonly router: Router, public sharedUtilService: SharedUtilService ) { }
	confirmSession = CustomerSupportFactory.buildconfirmSession();
	userData = CustomerSupportFactory.buildUserData();
	get state(): CustomerSupportState 
	{
		return this.state$.value;
	}

	public updateState(value: CustomerSupportState): void 
	{
		this.state$.next(value);
	}
	get stateChanged(): Observable<CustomerSupportState> 
	{
		return this.state$.asObservable();
	}
	public getCustomerSupportState(): void 
	{
		this.state.loading= false;
		const customerLabel = this.localStorageService.getCustomerAemLabels();
		if(customerLabel !== null && customerLabel !== undefined)
		{
			const labels: CustomerSupportAemLabel = <CustomerSupportAemLabel>JSON.parse(customerLabel);
			this.mapCustomerSupportState(labels);
		}
		else
		{
			this.apiService.getCustomerSupportLabels().subscribe({
				next: (response: ApiResponse) => 
				{
					if (response) 
					{
						const responseObj = <CustomerSupportAemLabel>response.data;
						this.localStorageService.setCustomerAemLabels(JSON.stringify(responseObj));
						this.mapCustomerSupportState(responseObj);
					}
				},
				error: () => 
				{
					this.state.loading = false;
				}
			});
		}
	}

	mapCustomerSupportState(res: CustomerSupportAemLabel): void
	{
		this.state.pageHeading= res.pageHeading;
		this.state.startCTA.label = res.startCTA;
		this.state.title= res.title;
		this.state.email= res.email;
		this.state.startSession= res.startSession;
		this.state.description= res.description;
		this.state.modalNote= res.modalNote;
		this.state.loading= false;
		this.confirmSession.label = res.pageHeading;
	}

	startImpersonationSession(email: string, inboudUrl: boolean = false)
	{
		const payload = { email: email };
		this.apiService.startImpersonationSession(payload).subscribe({
			next: (res: ApiResponse) => 
			{
				const responseObj = <ApiResponse>res.data;
				this.state.loading = false;
				this.localStorageService.setImpersonateUser(JSON.stringify(responseObj));
				this.localStorageService.setCustomerToDashboard('true');
				this.sharedUtilService.isCustomerSupportSession$.next(true);
				const lang = this.translate.currentLang || 'en';
				if(inboudUrl)
				{
					const url = localStorage.getItem('inboudUrl');
					this.router.navigate([lang + url]);
				}
				else
				{
					this.router.navigate([lang + '/app/dashboard']);
				}
			},
			error: (error: HttpErrorResponse) => 
			{
				this.state.isInvalid = true;
				this.state.emailErrorMessage = error.error.message;
				this.state.loading = false;
			}
		});
	}

	validateImpersonationSession(email: string)
	{
		const payload = { email: email };
		this.state.loading = true;
		this.apiService.getValidImpersonateUserDetails(payload).subscribe({
			next: (res: ApiResponse) => 
			{
				const responseObj = <CustomerUserRawData>res.data;
				this.userData.email = responseObj.email;
				this.userData.name = responseObj.name;
				this.userData.role = responseObj.roleName;
				this.confirmSession.hidden = false;
				this.state.loading = false;
				this.localStorageService.setUserName(responseObj.name);
			},
			error: (error: HttpErrorResponse) => 
			{
				this.state.isInvalid = true;
				this.state.emailErrorMessage = error.error.message;
				this.confirmSession.hidden = true;
				this.state.loading = false;
			}
		});
	}
}
